/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Email_Check_InboxInputs */



/**
* | output |
* | --- |
* | "Check your inbox" |
*
* @param {Profile_Email_Check_InboxInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_email_check_inbox = /** @type {((inputs?: Profile_Email_Check_InboxInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Email_Check_InboxInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérifiez votre boîte de réception")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprueba tu bandeja de entrada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Verifique sua caixa de entrada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlla la tua casella di posta")
	return /** @type {LocalizedString} */ ("Check your inbox")
});